import { track } from "../track";

export const trackGenContentFail = (params: {
  content_id?: string;
  stage: "submission" | "generation";
  error: string;
}) => track({ event: "gen_content_fail", ...params });
